// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import AbstractAudioSystem from 'core/entities/systems/AbstractAudioSystem';

/**
 * System responsible for speech.
 */
class SpeechSystem extends AbstractAudioSystem {
  constructor() {
    super('SpeechSystem', ['SpeechComponent']);
  }

  /**
   * Get speech component
   * @param {Entity} entity
   * @return {SpeechComponent}
   */
  _getAudioComponent(entity) {
    return entity.speechComponent;
  }
  
  
  /**
    * Get speeches for a speechComponent
    * @param {Entity} entity 
    * @return {Array<Speech>}
    */
  _getAudio(entity) {
    return entity.speechComponent.speeches;
  }

}

export default SpeechSystem;
